export const profileIdentityDetails = {
    title: "Profile Identity",
    description: `Before you can be included in the invitee’s organization’s blockchain you will need it to provide your Metamask wallet address. This will allow you to gain access, be assigned role permissions, and have your own wallet to collect ${process.env.REACT_APP_TOKEN_NAME} tokens that will be distributed by the owner.`,
    METAMASK_ADDRESS: {
        id: "Metamask Address",
        name: "metamaskAddress",
        label: "Metamask Address",
        icon: true,
    },
};
